/**
 * The related column is the shared default from @evo-flywheel/ui (UI contract rule 13). The kit
 * only supplies what the shell cannot know: its full descriptor set (spines are not registry
 * modules), which types have pages, and the Italian edge labels of its spine model.
 */
import { configureRelatedRecords } from "@evo-flywheel/ui";
import { descriptors } from "@kit/descriptors/index";
import { edgeTypes, factTypes } from "@kit/spines";
import { kernel } from "../api";
import { resourceBySlug } from "../kit-resources";

const factOf = new Map(Object.entries(factTypes).map(([fact, node]) => [node.slug, fact]));

configureRelatedRecords({
  fetchKernel: (path) => kernel(path),
  descriptors: descriptors.map((d) => ({
    slug: d.slug,
    label: { singular: d.label.singular, plural: resourceBySlug[d.slug]?.meta.label ?? d.label.plural },
    relations: d.relations,
    icon: d.ui && typeof d.ui === "object" && "icon" in d.ui ? (d.ui.icon as string | undefined) : undefined,
  })),
  isRoutable: (slug) => Boolean(resourceBySlug[slug]),
  // the same relation name may mean different things per type pair (affects: incident vs risk)
  edgeLabel: (relation, fromSlug, toSlug) => {
    const from = factOf.get(fromSlug), to = factOf.get(toSlug);
    return (edgeTypes.find((x) => x.relation === relation && x.from === from && x.to === to)
      ?? edgeTypes.find((x) => x.relation === relation))?.label;
  },
});
